import Joi from 'joi';

import { ChargeTypeEnum } from '../../../../enums/charge-type.enum';
import { PricingPresetRequirementEnum } from '../../../../enums/pricing-preset-requirement.enum';
import { TaxRateTypeEnum } from '../../../../enums/tax-rate-type.enum';
import { PricingItemTypeEnum } from '../../../pricing-items/enums/pricing-item-type.enum';

/**
 * Schema for vehicle category pricing item preset validation.
 */
export const vehicleCategoryPricingItemPresetSchema = () =>
  Joi.object({
    id: Joi.number().allow(null),
    uuid: Joi.string().allow(null),
    name: Joi.string().required().max(256).messages({
      'any.required': 'validations|pricing-item-preset-name|required',
      'string.max': 'validations|pricing-item-preset-name|max-length',
    }),
    description: Joi.string().allow(null, '').max(256),
    type: Joi.string()
      .valid(...Object.values(PricingItemTypeEnum))
      .messages({
        'any.only': 'validations|pricing-item-preset-type|invalid-value',
      }),
    taxRateType: Joi.string()
      .valid(...Object.values(TaxRateTypeEnum))
      .messages({
        'any.only':
          'validations|pricing-item-preset-tax-rate-type|invalid-value',
      }),
    unitPrice: Joi.number().allow(null),
    sortOrder: Joi.number().allow(null),
    pricingItemTemplateId: Joi.number().allow(null),
    hasUnits: Joi.boolean().allow(null),
    maxUnits: Joi.number().allow(null).integer().min(1),
    chargeType: Joi.string()
      .valid(...Object.values(ChargeTypeEnum))
      .default(ChargeTypeEnum.DAILY),
    presetRequirement: Joi.string()
      .valid(...Object.values(PricingPresetRequirementEnum))
      .default(PricingPresetRequirementEnum.OPTIONAL),
    // NOT NULL boolean: omit = leave untouched on update; null treated as unset.
    // Do not .default(false) here — shared create/update schema must preserve omit.
    isStandardDiscountApplied: Joi.boolean().empty(null),
  }).unknown();
